import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV2 } from "api/firebase";
import { RequestKey } from "api/request-key";

const invalidate = (qc: ReturnType<typeof useQueryClient>) => {
  qc.invalidateQueries([RequestKey.GetMyVerifiedDomains]);
  qc.invalidateQueries([RequestKey.GetVerifiedDomainsByAdmin]);
  qc.invalidateQueries([RequestKey.CheckVerifiedDomains]);
};

type CreateVerifiedDomainArgs = {
  url: string;
  showId?: string | null;
};

export const useCreateVerifiedDomain = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ url, showId }: CreateVerifiedDomainArgs) =>
      apiV2.verifiedDomain.create({ url, showId }),
    onSuccess: () => invalidate(qc),
  });
};

export const useUpdateVerifiedDomain = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      url,
      isApproved,
    }: {
      id: string;
      url?: string;
      isApproved?: boolean | null;
    }) => apiV2.verifiedDomain.update({ id }, { url, isApproved }),
    onSuccess: () => invalidate(qc),
  });
};

export const useDeleteVerifiedDomain = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiV2.verifiedDomain.delete({ id }),
    onSuccess: () => invalidate(qc),
  });
};
